<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; gap: 20px;">
  <div></div>
  <div style="display: flex; flex-direction: row; gap: 20px;">
    <div></div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <mat-toolbar color="primary" class="toolbar-over-card">
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
          <mat-card-title>Edit User</mat-card-title>
        </div>
      </mat-toolbar>
      <div style="flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined">
          <mat-card-content style="margin-bottom: 0px; display: flex; flex-direction: row;">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; margin: 20px;">
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <div style="box-sizing: border-box; display: flex; place-content: center flex-start; align-items: center;">
                  <div style="box-sizing: border-box; display: flex; flex: 1 1 60px; min-width: 60px; max-width: 60px; margin-bottom: 20px;">
                    <mat-icon class="circle-icon">face</mat-icon>
                  </div>
                  <div style="text-align: left; flex: 1 1 0%; box-sizing: border-box;">{{user.userName}}</div>
                </div>
              </div>
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <mat-form-field class="full-width">
                  <mat-label>User Type</mat-label>
                  <mat-select [(ngModel)]="userType" (selectionChange)="selectUserTypeChange()">
                    <mat-option *ngFor="let userType of accountUserTypes.all" [value]="userType.guid">{{userType.name}}</mat-option>
                    <mat-option *ngIf="user.userType === accountUserTypes.custom.guid" [value]="accountUserTypes.custom.guid">{{accountUserTypes.custom.name}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div style="flex: 1 1 0%; box-sizing: border-box;">
                <mat-form-field class="full-width">
                  <mat-label>Two Factor Authentication</mat-label>
                  <mat-select [(ngModel)]="twoFactorEnabled">
                    <mat-option [value]="true">Enabled</mat-option>
                    <mat-option [value]="false">Disabled</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column; margin: 20px">
              <div style="flex: 1 1 0%; box-sizing: border-box;" *ngIf="userType !== accountUserTypes.limitedUser.guid">
                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                  <div style="display: flex; justify-content: flex-start;">
                    <mat-label class="title">Case Access</mat-label>
                  </div>
                  <div style="display: flex; justify-content: flex-end;">
                    <div>
                      <a class="link" [routerLink]="[]" (click)="selectAllAccess()">All</a>
                    </div>
                    <div>
                      <a class="link" [routerLink]="[]" (click)="removeAllAccess()">None</a>
                    </div>
                  </div>
                </div>
                <mat-selection-list class="list" [(ngModel)]="caseIds" style="text-align: left;">
                  <mat-list-option *ngFor="let case of cases" [value]="case.caseId"> 
                    <span matListItemTitle style="display: flex; align-items: center;">{{case.caseName}}</span></mat-list-option>
                </mat-selection-list>
              </div>
              <div style="flex: 1 1 0%; box-sizing: border-box;" *ngIf="userType === accountUserTypes.limitedUser.guid">
                <div>
                  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
                    <mat-label class="title">Custom Coding Fields</mat-label>
                  </div>
                  <div style="box-sizing: border-box; display: flex; flex: 1 1 40px; place-content: center flex-end; align-items: center;">
                    <a class="link" [routerLink]="[]" (click)="selectAllFields()">All</a>
                  </div>
                  <div style="box-sizing: border-box; display: flex; flex: 1 1 40px; place-content: center flex-end; align-items: center;">
                    <a class="link" [routerLink]="[]" (click)="removeAllFields()">None</a>
                  </div>
                </div>
                <mat-selection-list class="list" [compareWith]="compareCustomFields" [(ngModel)]="selectedCustomFields" (selectionChange)="selectCustomFieldChange($event)" style="display:inline-block; width:100%; text-align: left" #selectionList>
                  <mat-list-option *ngFor="let customField of customFields" [value]="customField">
                    <div style="flex: 1 1 100%; box-sizing: border-box; max-width: 49%">
                      {{customField.caseName}}
                    </div>
                    <div style="box-sizing: border-box; display: flex; flex: 1 1 49%; font-size: 12px;">
                      {{customField.title}}
                    </div>
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-right: 20px;">
              <button mat-button color="primary" type="submit" (click)="updateAccountUser()">Update</button>
              <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div></div>
  </div>
  <div></div>
</div>
